import { useEffect, useRef, useState } from "react";
import UsersHeader from "./Header";
import UsersSearch from "./Search";
import UsersTable from "./Table";
import UserFormModal from "./Table/Row/UserFormModal";
import DeleteUserDialog from "./Table/Row/DeleteUserDialog";

import useUsers from "./Hook/useUsers";
import { useSelector } from "react-redux";
import UsersFilters from "./Filters";

const UsersContent = () => {

    const { filtered, total, page, pages } = useSelector(state => state.adminUsers);

    const {
        loading,
        search,
        setSearch,
        createUser,
        updateUser,
        deleteUser,

        role,
        setRole,
        sort,
        setSort,

        loadingMore,
        hasMore,
        initialLoaded,

        fetchUsers

    } = useUsers();

    const [editingUser, setEditingUser] = useState(null);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [openForm, setOpenForm] = useState(false);

    const loadMore = async () => {
        if (loadingMore || loading || !hasMore) return;

        await fetchUsers(
            search || "",
            role || "all",
            sort || "newest",
            page + 1
        );
    };

    return (
        <div className="space-y-6">
            

            <UsersHeader onAdd={() => {
                setEditingUser(null);
                setOpenForm(true);
            }} />

            {/* <UsersSearch value={search} onChange={setSearch} /> */}

            <UsersFilters 
                search={search}
                setSearch={setSearch}
                role={role}
                setRole={setRole}
                sort={sort}
                setSort={setSort}
            />


            <UsersTable
                users={filtered}
                loading={loading}
                onEdit={(u) => {
                    setEditingUser(u);
                    setOpenForm(true);
                }}
                onDelete={(u) => setDeleteTarget(u)}
            />

            {openForm && (
                <UserFormModal
                    user={editingUser}
                    onClose={() => setOpenForm(false)}
                    onSubmit={editingUser ? updateUser : createUser}
                />
            )}

            {deleteTarget && (
                <DeleteUserDialog
                    user={deleteTarget}
                    onClose={() => setDeleteTarget(null)}
                    onConfirm={() => deleteUser(deleteTarget._id)}
                />
            )}

            {hasMore && (
                <div className="flex justify-center mt-6">
                    <button
                    onClick={loadMore}
                    disabled={loadingMore}
                    className="px-4 py-2 bg-gradient-to-r from-[#543389] to-[#8b6bd9] text-white rounded-lg  disabled:opacity-50"
                    >
                    {loadingMore ? "در حال بارگذاری..." : "بارگذاری کاربران بیشتر"}
                    </button>
                </div>
            )}

        </div>
    );
};

export default UsersContent;